import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = ["label"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_38 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_39 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = { class: "form-check-label fw-bold ms-2" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "col-lg-8 fv-row" }
const _hoisted_47 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_48 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_49 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "col-lg-8 fv-row" }
const _hoisted_51 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { class: "form-check-label fw-bold ms-2" }
const _hoisted_54 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_55 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "form-check-label fw-bold ms-2" }
const _hoisted_60 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_61 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_62 = { class: "indicator-label" }
const _hoisted_63 = { class: "indicator-progress" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'assets'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewArea')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.areaSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('areaNameArLang')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('areaNameEnLang')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('Government')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "governorateId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedGov,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGov) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          disabled: "",
                          selected: "",
                          value: "0",
                          label: _ctx.translate('selectGovernment')
                        }, null, 8, _hoisted_20),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.govs, (gov) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: gov.id,
                            value: gov.id
                          }, _toDisplayString(gov.titleAr), 9, _hoisted_21))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('isRegisteredTrades')) + ": ", 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isRegisteredTrades",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.translate('isAd')) + ": ", 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isAd",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.translate('isAuction')) + ": ", 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isAuction",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('isPriceIndex')) + ": ", 1),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isPriceIndex) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isPriceIndex]
                      ])
                    ])
                  ])
                ]),
                (_ctx.isPriceIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('viewTypes')) + ": ", 1),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewTypesByIndexType[_ctx.IndicesType.PRICE_INDEX.id], (vt) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: vt.id,
                              class: "form-check form-check-custom form-check-solid me-4"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.viewAvailabilities[vt.id]) = $event)
                              }, null, 8, _hoisted_42), [
                                [_vModelCheckbox, _ctx.viewAvailabilities[vt.id]]
                              ]),
                              _createElementVNode("span", _hoisted_43, _toDisplayString(vt.title_ar), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.translate('isVolumeIndex')) + ": ", 1),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isVolumeIndex) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isVolumeIndex]
                      ])
                    ])
                  ])
                ]),
                (_ctx.isVolumeIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.translate('viewTypes')) + ": ", 1),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewTypesByIndexType[
                    _ctx.IndicesType.VOLUME_INDEX.id
                  ], (vt) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: vt.id,
                              class: "form-check form-check-custom form-check-solid me-4"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.viewAvailabilities[vt.id]) = $event)
                              }, null, 8, _hoisted_52), [
                                [_vModelCheckbox, _ctx.viewAvailabilities[vt.id]]
                              ]),
                              _createElementVNode("span", _hoisted_53, _toDisplayString(vt.title_ar), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPriceIndex || _ctx.isVolumeIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.translate('supportedCategories')) + ": ", 1),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicesPropertyCategories, (category) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: category.id,
                              class: "form-check form-check-custom form-check-solid me-4"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                value: category.id,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.supportedCategories) = $event))
                              }, null, 8, _hoisted_58), [
                                [_vModelCheckbox, _ctx.supportedCategories]
                              ]),
                              _createElementVNode("span", _hoisted_59, _toDisplayString(category.titleAr), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_61, [
                  _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_63, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_64
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}